module.exports = __webpack_public_path__ + "static/img/logo_du.995628d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_du.png
// module id = Viby
// module chunks = 33